import { chartTableFlatTransformer } from '@/utils/reports/chartTableFlatTransformer';

export const offersTrendTransformer = ({ response }) => {
  const { chart = [], headers, lookups } = response || {};
  const { dt, g1, g2 } = lookups || {};

  const transformedData = chartTableFlatTransformer({
    headers,
    data: chart,
    g1,
    g2,
    dt,
  });

  const categories = []; // x axis data for chart
  const series = []; // y axis data for chart

  // all available keys here are
  // offers, time_to_offer, accepted_offers, time_to_close_offer

  // Todo: here offers key is hardcoded for now, since only that is used in the chart
  transformedData.forEach(({ dt_display, offers }) => {
    categories.push(dt_display); // Use pre-formatted month from transformer
    series.push(offers);
  });

  return {
    categories,
    series,
  };
};
